export const environment = {
  production: true,
  apiUrl: 'https://app-summa-web-backend.azurewebsites.net',
  imagesUrl: 'https://stsummaweb.blob.core.windows.net/images'
};
